<template>
<md-list-item>
    <md-layout md-row>
        <md-layout md-flex="25">
            <md-checkbox v-model="layerPerms" @change="changeEdit" v-if="editable"></md-checkbox>
            <md-checkbox v-model="layerPerms" @change="changeEdit" v-else disabled></md-checkbox>
        </md-layout>
    </md-layout>
    <span class="md-body-1">{{layer.title}}</span>
</md-list-item>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

const CollaboratorsNav = {
    name: 'CollaboratorsNav',
    props: ['layer', 'editable', 'collaborator'],
    data: function() {
        return {
            layerPerms: this.collaborator.layers[this.layer.id]
        };
    },
    computed: {
        ...mapGetters([
            'project'
        ])
    },
    methods: {
        changeEdit() {
            const collabRef = firebase.database().ref(`/projects/${this.project.id}/collaborators/${this.collaborator.uid}`);
            const layers = this.collaborator.layers;
            this.$nextTick(() => {
                layers[this.layer.id] = this.layerPerms;

                collabRef.child('layers').set(layers);
            });
        }
    },

    mounted: function() {}
};
export default CollaboratorsNav;

</script>

<style></style>


// WEBPACK FOOTER //
// layer-permission.vue?052e1768